export default (fn: Function, threshhold: number, scope: any) => {
  const thres: number = threshhold || 250;

  let last: number;
  let deferTimer: any;

  return (...args: any[]) => {
    const context = scope || this;
    const now: number = +new Date();

    if (last && now < last + thres) {
      // hold on to it
      clearTimeout(deferTimer);

      deferTimer = setTimeout(() => {
        last = now;
        fn.apply(context, args);
      }, thres);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
};
